// removed by extract-text-webpack-plugin
module.exports = {"page-owner-messenger-share-button":"_1aaHh"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SocialShare/MessengerShareButton.scss
// module id = ./src/components/SocialShare/MessengerShareButton.scss
// module chunks = 5